import './App.css';
import Router from './components/Router/Router';

function App() {
  return (
    <div className="App">
      <Router></Router>
    </div>
  );
}

export default App;
